<div *transloco="let t" #orderTreeNotificationModal cdkTrapFocus [cdkTrapFocusAutoCapture]="true">
    <div class="order-tree-notification-wrapper">
        <div class="primary-wrapper">
            <div class="header-wrapper">
                <span class="title">{{ this.modalState()?.removeItem ? t("modals.order_notification.removed_from_cart") : t("modals.order_notification.added_to_cart") }}</span>
                <button class="button-undecorated close-button" cdkFocusInitial [attr.aria-label]="'Close Order Details Modal'" (click)="closeModal()">
                    <cwo-round-icon [iconName]="iconNameType.close" [size]="'medium'" />
                </button>
            </div>
            @if (orderedItem()) {
                <cwo-cart-item-entry [triggeringArea]="'Order Tree Notification'" [displayQuantityControls]="(orderedItem()?.specialOrdinal ?? 0) < 0" [item]="orderedItemWithoutUpsells()!" [showDivider]="false" (quantityChange)="pauseTimer()" (delete)="pauseTimer()"/>
            }
            @if(modalState()?.special) {
                <span class="item-name">{{modalState()?.special.special}}</span>
            }
        </div>
        <div class="secondary-wrapper">
            @if ((orderedItem()?.sizeUpsell || orderedItem()?.ingredientUpsell) && upsellBtnLabel()) {
                <button class="upsell-button" (click)="upsellBtnClick(orderedItem()!)">
                    {{ upsellBtnLabel() }}
                </button>
            } 
            
            @if (upsellDoneMessage().length) {
                <span class="message">{{upsellDoneMessage()}}</span>
            }

            <div class="modal-buttons-wrapper">
                <button class="checkout-button" [routerLink]="storeIdService.getRoutePathSegments(['checkout'])" [state]="{triggeringArea: 'Order Tree Notifications', triggeringPoint: 'Checkout button'}" (click)="closeModal()">
                    <span class="checkout">{{ t("modals.order_notification.checkout") }}</span>
                    <span class="base-amount">${{storeConfig?.showSubTotalOnly ? order().subTotal.toFixed(2) : order().price.toFixed(2) }}</span>
                </button>

                @if (timeChangedMessage()) {
                    <div class="errors-wrapper">
                        <cwo-icon class="icon" [name]="iconNameType.error"></cwo-icon>
                        <span class="text-error">{{ timeChangedMessage() }}</span>
                    </div>
                }
    
                <cwo-accent-button style="width: 100%;" [accentButtonStyle]="accentButtonStyleType.CLEAR" [ariaLabel]="'Continue Shopping'" [fullWidth]="true" (click)="closeModal()">
                    <span class="shopping-button">{{ t("modals.order_notification.continue_shopping") }}</span>
                </cwo-accent-button>
            </div>
        </div>
    </div>
</div>